import { EventEmitter, Injectable } from "@angular/core";
import { Headers, Http, RequestOptions, Response, RequestMethod, ResponseContentType } from "@angular/http";
import { environment } from "../environments/environment";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Rx";
import { CacheKey } from './shared/constants/cachekey.constants';
import { CacheService } from "./shared/services/cache.service";
import { CookieService } from 'ngx-cookie-service';
import { SSO } from "./sso/sso.constants";
import { ApiUrlConstants } from "./common/constants/api.constants";

@Injectable()
export class AppService {
    cookieService: CookieService = new CookieService(document);
    constructor(
        private _http: Http,
        private _cacheService:CacheService
    ) { }
  
    /**
         * To get user information by token from the service 
         * @returns Observable
         */
    getUserInfo() {
        let token = SSO.isRemoveObsoleteCookie() ? localStorage.getItem(SSO.INTERNAL_ACCESS_TOKEN) : this.cookieService.get(SSO.INTERNAL_ACCESS_TOKEN);
       // let token = this._cacheService.get(CacheKey.AccessToken);
        let headers = new Headers();
        headers.append('token', token+"&&1");
        let options = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let m = this._http.get(ApiUrlConstants.enrollmentApigwUrl+"idserver-users/token", options).map(response => response.json())
            .catch(this.handleErrorObservable);
        return m;
    }

     /**
         * To get user access permissions by user name from the service 
         * @returns Observable
         */
    getUserAccessPermissions(userName:string) {
        let options = new RequestOptions({ method: RequestMethod.Get});
        let m = this._http.get(environment.accountThroughGateway+"authorization/permissions/"+userName, options)
                    .map((res: Response) => <String[]>res.json())
                    .catch(this.handleErrorObservable);
        return m;
    }


    /**
       * To handle the obervable error response
       * @param  {Response|any} error
       */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error.message || error);
    }
    
  
}


// WEBPACK FOOTER //
// ./src/app/app.service.ts